jQuery(document).ready(function($) {
    $('body.page-our-work .form-toggle #toggle-checkbox, body.page-template-venues-and-private-parties .green-contact-section .form-toggle #toggle-checkbox, body.page-template-delta-innovate .green-contact-section .form-toggle #toggle-checkbox').on('change', function() {
        if ($(this).is(':checked')) {
            $('.our-work-contact').slideDown();
        } else {
            $('.our-work-contact').slideUp();
        }
    });
    $('body.page-template-equipment-hire-sales .recent-arrivals-carousel').slick({
        infinite: false,
        slidesToShow: 3.5,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2.15,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.15,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('body.page-template-equipment-hire-sales .reviews-carousel').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true
    });
    $('body.page-template-about-us .expanding-text-section .click-to-expand').click(function(){
       $(this).toggleClass('button-expanded');
       if ( $(this).hasClass('button-expanded') ) {
           $(this).text('Read Less');
       }
       else {
           $(this).text('Read More');
       }
       $('.expanding-text').toggleClass('expanded');
    });
    $('body.page-template-about-us .what-we-offer-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.what-we-offer-nav'
    });
    $('body.page-template-about-us .what-we-offer-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.what-we-offer-carousel',
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: 0,
        arrows: false
    });
    $('body.page-template-about-us .why-choose-us-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.why-choose-us-nav'
    });
    $('body.page-template-about-us .why-choose-us-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.why-choose-us-carousel',
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: 0,
        arrows: false
    });
    $('body.page-template-about-us #positionsAccordion .apply-now').click(function(){
        var position_name = $(this).attr('data-position-name');
        $('.application-modal .position-input input').attr({'placeholder': position_name, 'value':position_name})
    });
    $('body.page-template-delta-innovate .projects-carousel').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.15,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('body.page-template-delta-innovate .equipment-section-carousel').slick({
        infinite: false,
        slidesToShow: 3.5,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3.5,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2.15,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.15,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('body.page-template-delta-innovate .service-section-carousel').slick({
        infinite: false,
        slidesToShow: 2.5,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1.75,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1.15,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('body.page-template-delta-innovate .partners-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.partners-nav'
    });
    $('body.page-template-delta-innovate .partners-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.partners-carousel',
        dots: true,
        focusOnSelect: true,
        arrows: false
    });
    $('body.page-template-delta-innovate .brands-carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        vertical: true,
        verticalSwiping: true
    });
    if ($('body').hasClass('page-deltalive-projects')) {
        var canBeLoaded = true;
        var page = parseInt(loadmoreprojects_params.current_page) + 1; // Start from the next page
        var maxPage = loadmoreprojects_params.max_page;

        $('#load-more-button').on('click', function() {
            if (!canBeLoaded) {
                return;
            }

            console.log('Load More button clicked');
            console.log('Current page:', page);
            $.ajax({
                url: loadmoreprojects_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'loadmoreprojects',
                    page: page
                },
                beforeSend: function() {
                    console.log('Sending AJAX request');
                    canBeLoaded = false;
                    $('#load-more-button').text('Loading...');
                },
                success: function(response) {
                    if (response.success) {
                        $('#load-more-container').append(response.data.content);
                        page++;
                        canBeLoaded = true;
                        $('#load-more-button').text('Load More');
                        if (page > response.data.max_page) {
                            $('#load-more-button').remove();
                            $('#no-results').show();
                        }
                    } else {
                        console.log('No more posts to load.');
                        $('#load-more-button').remove();
                        $('#no-results').show();
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        });
    }

    if ($('body').hasClass('page-deltalive-projects')) {
        var canBeLoaded = true;
        var page = parseInt(loadmoreprojects_params.current_page) + 1; // Start from the next page
        var maxPage = loadmoreprojects_params.max_page;

        $('#load-more-button').on('click', function() {
            if (!canBeLoaded) {
                return;
            }

            console.log('Load More button clicked');
            console.log('Current page:', page);
            $.ajax({
                url: loadmoreprojects_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'loadmoreprojects',
                    page: page
                },
                beforeSend: function() {
                    console.log('Sending AJAX request');
                    canBeLoaded = false;
                    $('#load-more-button').text('Loading...');
                },
                success: function(response) {
                    if (response.success) {
                        $('#load-more-container').append(response.data.content);
                        page++;
                        canBeLoaded = true;
                        $('#load-more-button').text('Load More');
                        if (page > response.data.max_page) {
                            $('#load-more-button').remove();
                            $('#no-results').show();
                        }
                    } else {
                        console.log('No more posts to load.');
                        $('#load-more-button').remove();
                        $('#no-results').show();
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        });
    }

});
